var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"networkConnect"},[_c('span',{staticClass:"content"},[_c('i',{staticClass:"el-icon-warning"}),_vm._v(_vm._s(_vm.$t(`HostCommon.${_vm.text ? _vm.text : _vm.msg}`)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }